import type { User } from '@/types/user-type'

export function isSuperAdmin(user: User | undefined): boolean {
  if (user?.uiCapabilities?.isSuperAdmin != null) {
    return user.uiCapabilities.isSuperAdmin
  }
  return user?.roles?.some((r) => r.name === 'SuperAdmin') ?? false
}

export function hasRole(user: User | undefined, roleName: string): boolean {
  if (roleName === 'SuperAdmin') {
    return isSuperAdmin(user)
  }
  return user?.roles?.some((r) => r.name === roleName) ?? false
}
